import { IOption } from '@user/components/Filters/typings'
import { IKnockStatus } from './typings'

/**
 * Name of the knock-status filter in the Lead, Draft Lead and Opportunity
 * filter sets. Shared so the filter drawers, the saved-preference reconciler
 * and the filter chips all agree on the key.
 */
export const KNOCK_STATUS_FILTER_NAME = 'knockStatusSettingId'

export const knockStatusesToOptions = (
  knockStatuses: IKnockStatus[],
): IOption[] =>
  knockStatuses.map(({ id, name }) => ({ value: id, label: name }))
